module.exports = __webpack_public_path__ + "static/media/and_scr_paste_receipt_chat.19d0b0da.png";